<template>
  <div
    v-if="!rightSideDrawer"
    :class="[ 'grid-x actions-row', buttonWrapper, buttonWrapperHeight, buttonWrapperPaddingSize]"
  >
    <div class="actions-row-column">
      <button
        class="secondary button expanded"
        :disabled="isClearAllDisabled"
        @click.prevent="handleClearAll(facet)"
      >
        Clear
      </button>
    </div>
    <div
      v-if="isDynamicFilters && !isFacetDropdown"
      class="actions-row-column"
    >
      <button
        class="primary button expanded"
        @click.prevent="applyFilterDynamic"
      >
        View {{ formattedItemCount }} items
      </button>
    </div>

    <div
      v-if="!isDynamicFilters"
      class="actions-row-column"
    >
      <button
        class="primary button expanded"
        @click.prevent="applyFilter"
      >
        View {{ formattedItemCount }} items
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import useMultiSelectButtons from '../../composables/useMultiSelectButtons';

const props = defineProps({
  // store facet
  facet: {
    type: Object,
    required: true,
  },
  parentFacet: {
    type: Object,
    required: true,
  },
  isBelowMaxHeight: {
    type: Boolean,
  },
  updateCheckboxCriteria: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits(['onClearAll']);

const {
  clearAllSelectedFacets,
  applyFilter,
  rightSideDrawer,
  formattedSlideoutProductCount,
  isFacetDropdown,
  buttonsGap,
  buttonHeight,
  buttonWrapper,
  buttonWrapperHeight,
  buttonWrapperPaddingSize,
  isClearAllDisabled,
  isDynamicFilters,
  applyFilterDynamic,
} = useMultiSelectButtons(props);

const formattedItemCount = computed(() => (+(formattedSlideoutProductCount.value.replace(/[.,\s]/g, '')) > 500 ? '500+' : formattedSlideoutProductCount.value));

function handleClearAll(facet) {
  if (isDynamicFilters.value) {
    // update store facets immediately
    props.updateCheckboxCriteria([]);
  } else {
    // update temporary selections ref property
    clearAllSelectedFacets(facet);
  }

  emit('onClearAll');
}
</script>

<style scoped lang="scss">
.button-wrapper {
    position: absolute;
    bottom: 0;
    padding-bottom: 32px;
    z-index: 100;
    width: calc(100% - v-bind(buttonsGap));
}

.button-wrapper-height {
    width: 100%;
    padding-top: 12px;
    padding-bottom: 32px;
}

.button-wrapper-size {
  padding-bottom: 0px;
  width: 100%;
  position: sticky;
  bottom: 0px;
}

.actions-row {
  grid-gap: rem-calc(15px);
  background-color: white;
  .actions-row-column {
    width: calc(50% - rem-calc(7.5px));
    max-width: 100%;
    flex-grow: 1;
    button {
      height: v-bind(buttonHeight)
    }
  }
}
</style>
